import { createContext, useContext, ReactNode } from 'react';
import { useWebRTC } from '../hooks/useWebRTC';
import { useCallComfort } from '../hooks/useCallComfort';

type WebRTCContextType = ReturnType<typeof useWebRTC>;

const WebRTCContext = createContext<WebRTCContextType | null>(null);

export function WebRTCProvider({ children }: { children: ReactNode }) {
  const value = useWebRTC();
  // пока идёт звонок — экран не гаснет, а при исходящем слышен гудок вызова
  useCallComfort(value.callState);
  return <WebRTCContext.Provider value={value}>{children}</WebRTCContext.Provider>;
}

export function useWebRTCContext(): WebRTCContextType {
  const ctx = useContext(WebRTCContext);
  if (!ctx) throw new Error('useWebRTCContext must be used inside WebRTCProvider');
  return ctx;
}
